module.exports = __webpack_public_path__ + "img/logo.b9d26ef4.svg";